import React, { useState, useEffect } from "react";
import DataGrid, {
  Column,
  Export,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Scrolling,
  LoadPanel,
  SearchPanel,
  ColumnChooser,
  ColumnChooserSearch,
  ColumnChooserSelection,
  Position,
  MasterDetail,
  Pager,
  Paging,
  Button,
} from "devextreme-react/data-grid";
import { Workbook } from "exceljs";
import { saveAs } from "file-saver-es";
import { exportDataGrid } from "devextreme/excel_exporter";
import "whatwg-fetch";
import Guid from "devextreme/core/guid";
import Modal from "react-bootstrap/Modal";
import { useStyles } from "../../Styles.js";
import { createStore } from "devextreme-aspnet-data-nojquery";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import Button1 from "@material-ui/core/Button";
import { api_path } from "../../shared.js";
import Select from "react-select";
import "../../modal.css";
import axios from "axios";
import swal from "sweetalert";
export function SalesOrderUserRoleDataGrid(props) {
  const [getCrmId, setCrmId] = useState(props.CRM_ID);
  const [getUserRole, setUserRole] = useState(props.USER_ROLE);
  const [getUserID, setUserID] = useState(props.USER_EMAIL);
  const [getEmpCode, setEmpCode] = useState(props.EMP_CODE);
  const classes = useStyles();
  const [getLoadGrid, setLoadGrid] = useState();
  const [getResult, setResult] = useState("");
  const [getErrMsg, setErrMsg] = useState("");
  const [getSale, setSale] = useState([]);
  const [saleList, setSaleList] = useState([]);
  const [selectSale, setSelectSale] = useState([]);

  const [getSale2, setSale2] = useState([]);
  const [saleList2, setSaleList2] = useState([]);
  const [selectSale2, setSelectSale2] = useState([]);
  const [getSaleCo, setSaleCo] = useState([]);
  const [saleCoList, setSaleCoList] = useState([]);
  const [selectSaleCo, setSelectSaleCo] = useState([]);

  const [getSaleAuthenCode, setSaleAuthenCode] = useState("");
  const pageSizes = [25, 50, 100];
  const [selectedValue, setSelectedValue] = useState("option1");
  const [getDateStr, setDateStr] = useState("");
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  useEffect(() => {
    setResult("");
    //setLoadGrid(randomNumberInRange(1,20))
    fetchSale();
  }, []);

  const handleSearch = (e) => {
    //setSearchStatus(1);
  };

  const styles = {
    radioButton: {
      padding: "12px 16px",
      borderRadius: "8px",
      margin: "8px",
      border: "2px solid #007BFF",
      background: "#fff",
      display: "inline",
      alignItems: "center",
      justifyContent: "center",
      width: "280px",
      cursor: "pointer",
      transition: "background-color 0.3s, color 0.3s",
    },
    selected: {
      background: "#007BFF",
      color: "#fff",
      borderColor: "#007BFF",
    },
    list: {
      listStyleType: "none",
      padding: 0,
      textAlign: "center",
      display: "inline-flex",
    },
  };
  const url =
    api_path +
    "/TS_SALES_ORDER_ROLE.php?sale=" +
    getSale.SALE_CODE
  const dataSource = createStore({
    key: "SALES_ORDER_ROLE_ID",
    loadUrl: `${url}`,
  });

  const columnChooserModes = [
    {
      key: "dragAndDrop",
      name: "Drag and drop",
    },
    {
      key: "select",
      name: "Select",
    },
  ];

  const fetchSale = () => {
    axios
      .get(
        api_path + `/GET_SALES.php?role=3`
      )
      .then((response) => {
        setSaleList(response.data);
        setSaleList2(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleSaleChange = (obj) => {
    setSelectSale(obj.SALE_CODE);
    setSale({ SALE_CODE: obj.SALE_CODE, SALE_NAME: obj.SALE_NAME });

  };
  const handleSaleChange2 = (obj) => {
    setSelectSale2(obj.SALE_CODE);
    setSale2({ SALE_CODE: obj.SALE_CODE, SALE_NAME: obj.SALE_NAME });

  };
  useEffect(() => {
    const getSaleCoDropdown = async () => {
      const resstate = await fetch(
        api_path +
          `/GET_CSANDSALESCO.php?sale=${getSale2.SALE_CODE}`
      );
      const getst = resstate.json();
      setSaleCoList(await getst);
    };
    getSaleCoDropdown().then();
  }, [getSale2]);
 
  const handleSaleCoChange = (obj) => {
    setSelectSaleCo(obj.CS_ID);
    setSaleCo({ CS_ID: obj.CS_ID, CS_EMAIL: obj.CS_EMAIL });

  };
  const randomNumberInRange = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };
  const onDeleteButtonClick = React.useCallback((e) => {
    const key = new Guid().toString();
    const dataRow = e.row && e.row.data;
    swal({
      title: "Are you sure to delete this order ?",
      text: "",
      icon: "info",
      dangerMode: false,
      buttons: true,
    }).then((isConfirm) => {
      if (isConfirm) {
        delBooking(e.row.key);
      }
    });
  }, []);
  const delBooking = async (id) => {
    try {
      const response = await axios.delete(
        api_path + `/TS_SALES_ORDER.php?order_id=${id}`
      );
      setLoadGrid(randomNumberInRange(1, 20));
    } catch (error) {
      console.error(error);
    }
  };


  const onEditButtonClick = React.useCallback((e) => {
    const key = new Guid().toString();
    const dataRow = e.row && e.row.data;
    window.open(
      "/s-crm/SalesOrderForm?order_id=" +
        e.row.key +
        "&loadtype=" +
        dataRow.LOADTYPE,
      "_blank"
    );
  }, []);
  const handleAddButtonClick = React.useCallback((e) => {
    setShow(true);
  }, []);
  const searchEditorOptions = { placeholder: "Search column" };
  const columnChooserModeLabel = { "aria-label": "Column Chooser Mode" };
  const onExporting = (e: DataGridTypes.ExportingEvent) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("Main sheet");
    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], { type: "application/octet-stream" }),
          "SalesOrderRole.xlsx"
        );
      });
    });
  };
  const cellPrepared = (e) => {
   
  };
 
  //Column Chooser
  const [mode, setMode] = React.useState(columnChooserModes[1].key);
  const [searchEnabled, setSearchEnabled] = React.useState(true);
  const [allowSelectAll, setAllowSelectAll] = React.useState(true);
  const [selectByClick, setSelectByClick] = React.useState(true);
  const [recursive, setRecursive] = React.useState(true);

  //end column chooser
  const numberFormat = (value) =>
    new Intl.NumberFormat("en-IN", {}).format(value);
  const Search = () => {
    const [showResults, setShowResults] = React.useState(false);
    const onClick = () => setShowResults(true);
    return (
      <div>
        <input type="button" value="Search" onClick={onClick} />
        {showResults ? <Results /> : null}
      </div>
    );
  };
  const Results = () => (
    <div id="results" className="search-results">
      Some Results
    </div>
  );
  const customStyles = {
    control: (provided) => ({
      // class attribute : class=" css-i32vvf-control"
      ...provided,
      fontSize: 14,
      background: "#119f4a",
      color: "white",
      display: "flex",
      flexWrap: "nowrap",
      width: "15em",
    }),
    menu: (provided) => ({
      // 'menu' is from the div class too.
      ...provided,
      background: "white",
      color: "#333",
    }),
    select: (provided) => ({
      // 'menu' is from the div class too.
      ...provided,
      fontSize: 14,
      color: "blue",
    }),
    option: (provided) => ({
      // 'menu' is from the div class too.
      ...provided,
      fontSize: 14,
    }),
    input: (provided) => ({
      ...provided,
      fontSize: 14,
      color: "white",
      width: "80px !important",
      border: "none",
      margin: "0px 0px 0px 0px",
    }),
  };
  function addUser(
  ) {
    var data = {
      SALE_CODE: getSale2.SALE_CODE,
      CS_ID: getSaleCo.CS_ID,
    };
    fetch(api_path + "/TS_SALES_ORDER_ROLE.php", {
      method: "POST",
      headers: {
        Accept: "application/form-data",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result["status"] == "200") {
          swal("Done.", "Save data successfully.", "success", {
            buttons: true,
            timer: 5000,
          }).then(function () {
   
          });
        } else {
          swal("Sorry", result["message"], "error", {
            buttons: true,
            timer: 5000,
          });
        }
      });
  }

  return (
    <Container maxWidth="xl">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          &nbsp;
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <label className="head">Sales Order User Role</label>
        </Grid>
        <Grid item xs={12} sm={3}></Grid>
        <Grid
          item
          xs={12}
          sm={3}
          style={{ display: "flex" }}
          justify="flex-end"
        >
         
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={3}>
          <label>SALES</label>
          <Select
            className="multiselect1"
            placeholder="Select..."
            value={getSale}
            options={saleList}
            onChange={handleSaleChange}
            getOptionLabel={(x) => x.SALE_NAME}
            getOptionValue={(x) => x.SALE_CODE}
            required
          />
        </Grid>
    
  
        
        <Grid item xs={12} sm={3}>
          <div style={{ paddingTop: 7 + "px" }}>&nbsp;</div>
          <Button1
            className="searchButton"
            type="button"
            variant="contained"
            color="primary"
            onClick={handleSearch}
          >
            Search
          </Button1>
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          style={{ display: "flex" }}
          justify="flex-end"
        >
            
          <Button1
            className="addBtn"
            type="button"
            variant="contained"
            color="primary"
            onClick={handleAddButtonClick}
          >
            New
          </Button1>

        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <div className="labelError">{getResult}</div>
          <div className="labelResult">{getDateStr}</div>
        </Grid>
      </Grid>
      <br />
      <Grid container className={classes.root}>
        <br />
        <DataGrid
          onCellPrepared={cellPrepared}
          dataSource={dataSource}
          showBorders={true}
          columnAutoWidth={true}
          rowAlternationEnabled={true}
          showScrollbar={true}
          keyExpr="SALES_ORDER_ROLE_ID"
          onExporting={onExporting}
        >
          <Scrolling
            rowRenderingMode="virtual"
            showScrollbar="always"
            useNative="false"
            scrollByThumb="true"
          ></Scrolling>
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <HeaderFilter visible={true} />
          <SearchPanel
            visible={true}
            width={240}
            placeholder="Full Text Search..."
          />
          <Column
            dataField="SALES_ORDER_ROLE_ID"
            defaultSortOrder="desc"
            visible={false}
          />
          <Column dataField="SALES_EMAIL" caption="SALES" width={300} />
          <Column dataField="USER_EMAIL" caption="MEMBER" width={300} />
          <Column dataField="ROLE_NAME" caption="ROLE" />
          <Column dataField="USER_FIRSTNAME" caption="FIRSTNAME" />
          <Column dataField="USER_LASTNAME" caption="LASTNAME" />
          <Column type="buttons" width={30}>
            <Button icon="edit" onClick={onEditButtonClick} hint="Edit Order"  
            //visible={isEditIconVisible}
            />
          </Column>
 
         
          <Column type="buttons" width={30}>

            <Button
              icon="trash"
              onClick={onDeleteButtonClick}
              hint="Delete"
//visible={isDelelteIconVisible}
            />
          </Column>
        
       
          <ColumnChooser enabled={true} mode={mode}>
            <Position
              my="right top"
              at="right bottom"
              of=".dx-datagrid-column-chooser-button"
            />

            <ColumnChooserSearch
              enabled={searchEnabled}
              editorOptions={searchEditorOptions}
            />

            <ColumnChooserSelection
              allowSelectAll={allowSelectAll}
              selectByClick={selectByClick}
              recursive={recursive}
            />
          </ColumnChooser>
          <LoadPanel enabled={true} />
          <Export enabled={true} allowExportSelectedData={true} />
          <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
          <Paging defaultPageSize={25} />
        </DataGrid>
      </Grid>
      <Modal
        className="modal"
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
        <Modal.Title>Add</Modal.Title>
        </Modal.Header>

        <Modal.Body className="grid-example">
          <form
            onSubmit={(e) => {
              handleClose();
              e.preventDefault();
              addUser(
                // GET_ITEM_ID,
                // props.data.key,
                // GET_USER_ID
              );
            }}
            id="editmodal"
            className=""
          >
          <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <label>SALES</label>
          <Select
           styles={{
            menu: (provided) => ({ ...provided, zIndex: 9999 }),
          }}
            className="multiselect1"
            placeholder="Select..."
            value={getSale2}
            options={saleList2}
            onChange={handleSaleChange2}
            getOptionLabel={(x) => x.SALE_NAME}
            getOptionValue={(x) => x.SALE_CODE}
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}>  &nbsp;  </Grid>
        <Grid item xs={12} sm={6}>
          <label>MEMBER</label>
          <Select
            className="multiselect2"
            placeholder="Select..."
            value={getSaleCo}
            options={saleCoList}
            onChange={handleSaleCoChange}
            getOptionLabel={(x) => x.CS_EMAIL}
            getOptionValue={(x) => x.CS_ID}
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}>  &nbsp;  </Grid>
        </Grid>
          </form>
        </Modal.Body>

        <Modal.Footer>
          <button className="btn btn-secondary" onClick={handleClose}>
            Close
          </button>
          <button className="btn btn-primary" form="editmodal">
            Save
          </button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}
